// collectionDefaults.ts - Çek/Senet tahsil penceresi için varsayılan yöntem ve banka seçimi
// NOT: servis modülü (API istemcisi) içe aktarılmaz — saf yardımcılar, birim testlenir
const IN_COLLECTION = 'IN_COLLECTION';
const PARTIAL_COLLECTED = 'PARTIAL_COLLECTED';

// Tahsilat yöntemi: Kasa / Banka / Elden Teslim (hareketsiz)
export type CollectionMethod = 'CASHBOX' | 'BANK' | 'HAND';

type CollectionNote = {
  status: string;
  collectionBankAccountId?: number | null;
  collectionBankSubAccountId?: number | null;
};

/**
 * Çek tahsil için bankaya gönderilmiş mi? (Tahsilde veya kısmi tahsilde + gönderilen banka kayıtlı)
 */
export const isSentToBank = (note: CollectionNote | null | undefined): boolean =>
  !!note &&
  (note.status === IN_COLLECTION || note.status === PARTIAL_COLLECTED) &&
  !!note.collectionBankAccountId;

/**
 * Banka seçim listesindeki seçenek id'si: ana hesap için bankaId, alt hesap için "bankaId_altId".
 */
export const getSentBankOptionId = (note: CollectionNote | null | undefined): number | string | null => {
  if (!note || !isSentToBank(note)) return null;
  return note.collectionBankSubAccountId
    ? `${note.collectionBankAccountId}_${note.collectionBankSubAccountId}`
    : (note.collectionBankAccountId as number);
};

/**
 * Varsayılan tahsilat yöntemi: bankaya gönderilmiş çekte Banka, diğerlerinde Kasa.
 */
export const getDefaultCollectionMethod = (note: CollectionNote | null | undefined): CollectionMethod =>
  isSentToBank(note) ? 'BANK' : 'CASHBOX';

/**
 * Bankaya gönderilmiş çekte Kasa / Elden Teslim seçilirse uyarı gösterilir (para bankaya yazılmaz).
 */
export const shouldWarnNonBankCollection = (
  note: CollectionNote | null | undefined,
  method: CollectionMethod
): boolean => isSentToBank(note) && method !== 'BANK';

/**
 * Banka seçenek id'sini ana hesap / alt hesap id'lerine ayırır ("5_7" → 5 + 7, 5 → 5).
 */
export const parseBankOptionId = (
  id: number | string | null | undefined
): { bankAccountId?: number; bankSubAccountId?: number } => {
  if (id === null || id === undefined || id === '') return {};
  if (typeof id === 'number') return { bankAccountId: id };
  const [main, sub] = String(id).split('_');
  const bankAccountId = parseInt(main, 10);
  const bankSubAccountId = sub !== undefined ? parseInt(sub, 10) : NaN;
  return {
    bankAccountId: Number.isFinite(bankAccountId) ? bankAccountId : undefined,
    bankSubAccountId: Number.isFinite(bankSubAccountId) ? bankSubAccountId : undefined
  };
};
